import type { RouteRecordNormalized } from 'vue-router';
import { electronInitRoute } from '@/utils/electronHelper';

const modules = import.meta.glob('./modules/*.ts', { eager: true });
// const externalModules = import.meta.glob('./externalModules/*.ts', {
//   eager: true,
// });

function formatModules(_modules: any, result: RouteRecordNormalized[]) {
  Object.keys(_modules).forEach((key) => {
    const defaultModule = _modules[key].default;
    if (!defaultModule || defaultModule.meta?.hideInMenu) return;
    const moduleList = Array.isArray(defaultModule)
      ? [...defaultModule]
      : [defaultModule];
    result.push(...moduleList);
  });
  return result;
}

const result = formatModules(modules, []);
const electronResult: any[] = electronInitRoute(result);

export const appRoutes: RouteRecordNormalized[] = result;

export const electronRoutes: any[] = electronResult;

export const appExternalRoutes: RouteRecordNormalized[] = formatModules([], []);
